import { render } from "./AdminDashboard.vue?vue&type=template&id=71a75cbd"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script